import { Autocomplete, FormHelperText, MenuItem, Paper, TextField, Typography } from '@mui/material';
import { Box, maxWidth } from '@mui/system';
import { Field } from 'formik';
import React from 'react';
import DatePickerCustom from '../../../../../components/DatePicker/DatePickerCustom';
import GlobalSelectField from '../../../../../components/mui/GlobalSelectField';
import { genders } from '../util/genders';
import { bloodGroupJson } from '../util/bloodGroup';

export default function StudentDetailsSection({
  touched,
  errors,
  values,
  loading,
  classes,
  syllabuses,
  countryCodeAndCountry,
  dayjs,
  setFieldValue,
  medium,
}) {
  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        Student Details
      </Typography>
      <Box display={'flex'} gap={2} flexDirection={'column'} maxWidth={900}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            label="Admn No"
            name="admnNo"
            disabled
            error={touched.admnNo && Boolean(errors.admnNo)}
            helperText={touched.admnNo && errors.admnNo}
          />

          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="studentName"
            label="Student Name"
            name="studentName"
            error={touched.studentName && Boolean(errors.studentName)}
            helperText={touched.studentName && errors.studentName}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="firstName"
            label="First Name"
            name="firstName"
            error={touched.firstName && Boolean(errors.firstName)}
            helperText={touched.firstName && errors.firstName}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="lastName"
            label="Last Name"
            name="lastName"
            error={touched.lastName && Boolean(errors.lastName)}
            helperText={touched.lastName && errors.lastName}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Box width={'100%'}>
            <Field
              name="gender"
              as={TextField}
              select
              label="Gender"
              fullWidth
              error={touched.gender && Boolean(errors.gender)}
              helperText={touched.gender && errors.gender}
            >
              {genders.map((e) => (
                <MenuItem key={e.id} value={e.name}>
                  {e.name}
                </MenuItem>
              ))}
            </Field>
          </Box>
          <Autocomplete
            fullWidth
            disabled={loading}
            name="medium"
            id="medium"
            options={medium}
            getOptionLabel={(option) => option.name || ''}
            onChange={(_, v) => setFieldValue('medium', v?.id)}
            value={medium?.find((MD) => MD.id == values.medium) || null}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Medium"
                error={touched.medium && Boolean(errors.medium)}
                helperText={touched.medium && errors.medium}
              />
            )}
          />

          {/* <Autocomplete
            fullWidth
            disabled={loading}
            name="classId"
            id="classId"
            options={classes}
            getOptionLabel={(option) => option.className || ''}
            value={classes?.find((syllabus) => syllabus.id == values.classId) || null}
            onChange={(_, v) => setFieldValue('classId', v?.id)}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Class"
                error={touched.classId && Boolean(errors.classId)}
                helperText={touched.classId && errors.classId}
              />
            )}
          /> */}
          <Autocomplete
            fullWidth
            disabled={loading}
            name="currentClass"
            id="currentClass"
            onChange={(_, v) => setFieldValue('currentClass', v?.id)}
            options={classes}
            getOptionLabel={(option) => option.className || ''}
            value={classes?.find((cls) => cls.id == values.currentClass) || null}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Student Class"
                error={touched.currentClass && Boolean(errors.currentClass)}
                helperText={touched.currentClass && errors.currentClass}
              />
            )}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            type="number"
            id="contactNumber"
            label="Contact Number"
            name="contactNumber"
            error={touched.contactNumber && Boolean(errors.contactNumber)}
            helperText={touched.contactNumber && errors.contactNumber}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Autocomplete
            fullWidth
            disabled={loading}
            name="syllabus"
            id="syllabus"
            options={syllabuses}
            getOptionLabel={(option) => option.name || ''}
            value={syllabuses?.find((syllabus) => syllabus.id == values.syllabus) || null}
            onChange={(_, v) => setFieldValue('syllabus', v?.id)}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Syllabus"
                error={touched.syllabusId && Boolean(errors.syllabusId)}
                helperText={touched.syllabusId && errors.syllabusId}
              />
            )}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="email"
            type="email"
            label="Email"
            name="email"
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
            // sx={{ maxWidth: 300 }}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Autocomplete
            disabled={loading}
            fullWidth
            name="studentCountryCode"
            id="studentCountryCode"
            options={countryCodeAndCountry}
            getOptionLabel={(option) => option.label || ''}
            value={countryCodeAndCountry?.find((CNTRY) => CNTRY.phone_code == values.studentCountryCode) || null}
            onChange={(_, v) => setFieldValue('studentCountryCode', v?.phone_code)}
            renderInput={(params) => (
              <Field
                as={TextField}
                disabled
                fullWidth
                autoComplete="off"
                {...params}
                label="Student Country Code"
                error={touched.studentCountryCode && Boolean(errors.studentCountryCode)}
                helperText={touched.studentCountryCode && errors.studentCountryCode}
              />
            )}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            type="number"
            label="Whatsapp Number"
            name="whatsappNumber"
            error={touched.whatsappNumber && Boolean(errors.whatsappNumber)}
            helperText={touched.whatsappNumber && errors.whatsappNumber}
          />
          <DatePickerCustom
            sx={{ width: '100%' }}
            label="Date Of Birth"
            fullWidth={true}
            value={values.dateOfBirth ? dayjs(values?.dateOfBirth) : null}
            setValue={(date) => setFieldValue('dateOfBirth', date.format('YYYY-MM-DD'))}
            disableFuture={true}
            viewDetails={['year', 'month', 'day']}
            restrtictTyping={true}
            dateDisplayFormat="DD-MM-YYYY"
            error={touched.dateOfBirth && Boolean(errors.dateOfBirth)}
            helperText={touched.dateOfBirth && errors.dateOfBirth}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="bloodGroup"
            label="Blood Group"
            name="bloodGroup"
            error={touched.bloodGroup && Boolean(errors.bloodGroup)}
            helperText={touched.bloodGroup && errors.bloodGroup}
            select
          >
            {bloodGroupJson.map((e) => (
              <MenuItem value={e?.group} key={e?.id}>
                {e?.group}
              </MenuItem>
            ))}
          </Field>
        </Box>
      </Box>
    </Paper>
  );
}
